// src/routes/index.jsx
import '../App.css';
import LandingPage from '../components/Landing_Page/LandingPage';
import Navbar from '../components/Landing_Page/Navbar';
import '../NewDashStyles.css';
import { Capacitor } from '@capacitor/core';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import ScrollToTop from '../components/common/ScrollToTop';
import NewDash from '../NewDash';
import Pricing from '../components/Landing_Page/PricingPlans';
import Login from '../components/Login/Login';
import RegisterOrganization from '../components/SaaS/RegisterOrganization';
import Checkout from '../components/SaaS/Checkout';
import SuperAdminApp from '../super-admin/SuperAdminApp';
import AccountHeld from '../pages/AccountHeld';
import CustomerPortal from '../components/customer/CustomerPortal';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import DeleteAccount from '../pages/DeleteAccount';
import { isIosLoginOnlyApp } from '../lib/platform';

/** APK / native app opens on sign-in; the public marketing site stays at `/` on web. */
function AppHome() {
  if (Capacitor.isNativePlatform()) {
    return <Navigate to="/login" replace />;
  }
  return <LandingPage />;
}

function RegisterRoute() {
  if (isIosLoginOnlyApp()) {
    return <Navigate to="/login" replace />;
  }
  return <RegisterOrganization />;
}

function CheckoutRoute() {
  if (isIosLoginOnlyApp()) {
    return <Navigate to="/login" replace />;
  }
  return <Checkout />;
}

function PricingRoute() {
  if (isIosLoginOnlyApp()) {
    return <Navigate to="/login" replace />;
  }
  return (
    <div className="min-h-screen bg-zinc-100 font-sans">
      <Navbar />
      <main className="pt-16">
        <Pricing />
      </main>
    </div>
  );
}

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<AppHome />} />
        <Route path="/account-held" element={<AccountHeld />} />
        <Route path="/super-admin" element={<SuperAdminApp />} />
        <Route path="/dashboard" element={<NewDash />} />
        <Route path="/customer" element={<CustomerPortal />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/register" element={<RegisterRoute />} />
        <Route path="/checkout" element={<CheckoutRoute />} />
        <Route path="/pricing" element={<PricingRoute />} />
      </Routes>
    </BrowserRouter>
  );
}
